import httpInstance from '../httpInstance';

const createDistributionCenterService = async (dataParam) => {
  let res;
  const endpoint = '/delivery/v1/distribution-centers';
  const dataSent = dataParam;

  await httpInstance.post(
    endpoint,
    dataSent,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default createDistributionCenterService;
